import React from "react";
import SubTitle from "../common/SubTitle";
import DataBackup from "./DataBackup";
import ImportExport from "./ImportExport";
import DeleteData from "./DeleteData";
import Reports from "./Reports";
import { Box } from "@mui/material";

export default function ManageDataMain({ school = false } = {}) {

  const orgName = JSON.parse(localStorage.getItem('userState'))?.organization?.name;
  
  return (
    <>
      {/* <SubTitle
        title="Data Management"
        path={`${orgName || "organization"} > Reports > Data Management`}
      /> */}
      {/* <DataBackup /> */}
      {/* <Reports /> */}
      <ImportExport school={school} />
      <DeleteData />
      {/* <Box sx={{ height: "40vh" }}>

      </Box> */}
    </>
  );
}
